'use client';

import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { Button } from '@mui/material';
import { CARD_FINDER_OPEN_ACTION } from 'src/features/navigation/Entrypoint/constants';
import { getEntryPointUrl } from './utils';

export function EntrypointDesktopButton({
  entitySection = 'cardfinder_entry',
}: {
  entitySection?: string;
}) {
  const firePageAction = usePageAction({
    ...CARD_FINDER_OPEN_ACTION,
    actionSection: entitySection,
  });

  return (
    <FeatureViewed
      entityName="cc_recommend_flow"
      entitySection={entitySection}
      impressionPosition={0}
    >
      <Button
        href={getEntryPointUrl()}
        onClick={() => firePageAction()}
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          fontSize: '.875rem',
          letterSpacing: '.11rem',
          lineHeight: '.9',
        }}
      >
        Get Started
      </Button>
    </FeatureViewed>
  );
}
